


<div class="container-fluid forSpace hero mx-0-auto  backgroundMain   px-4 ">
  <div class="row flex-lg-row-reverse align-items-center  ">
    <div class=" col-sm-8 col-lg-6">
      <img src="{{ routeImageMain }}" class="d-block mx-lg-auto img-fluid imgHero"   loading="lazy" alt="MoviLink">
    </div>
    <div class="col-lg-6  ">
      <div class="my-4 mx-5">
        <span class=" fs-6 spanHeroTitleHero fw-bolder mb-3  text-light">{{ title }}</span>
      </div>
      <div class="texts mx-5">
        <h3 class=" lh-1 fs-1   text-light">{{ subtitle1 }}</h3>
        <span class="lh-1  fs-1  text-light fw-bolder">{{ subtitle2 }}</span>
      </div>
      <div class=" mx-5 d-grid gap-2 my-4 d-md-flex justify-content-md-start">
        <a type="button" href="https://api.whatsapp.com/send/?phone=%2B593993183975&text&type=phone_number&app_absent=0" target="_blank" class="bg-light fs-5 aHeroTitleHero text-center fw-bolder px-4 me-md-2 ">{{ callToAction }}</a>
      </div>
    </div>
  </div>
</div>


